<script setup>

  const props = defineProps({
    data: {
      default: null,
      type: Object
    },
    usesSlot: {
      default: false,
      type: Boolean
    },
    type: {
      default: 'text',
      type: String
    },
    class: {
      default: '',
      type: String
    },
    placeholder: {
      default: 'Type something...',
      type: String
    },
    selectValue: {
      default: '',
      type: String
    }
  })
  defineEmits(['update:selectValue'])
</script>

<template>
  <select
    v-if="props.usesSlot"
    :id="props.type"
    :name="props.type"
    :class="props.class"
    class="shadow px-2 py-3 rounded-md text-gray-400 placeholder:text-gray-400 bg-white text-xs placeholder-gray-300 w-full"
    @change="$emit('update:selectValue', $event.target.value)"
  >
    <option
      value=""
      disabled
      selected
    >
      {{ props.placeholder }}
    </option>
    <slot />
  </select>
  <select
    v-else
    id=""
    name=""
    :class="props.class"
    class="shadow px-2 py-2 rounded-md text-gray-400 bg-white text-xs placeholder-gray-300 w-full"
    @change="$emit('update:selectValue', $event.target.value)"
  >
    <option
      value=""
      disabled
      selected
    >
      {{ props.placeholder }}
    </option>
    <option
      v-for="(item, index) in props.data"
      :key="index"
      :value="item.value"
    >
      {{ item.name }}
    </option>
  </select>
</template>

<style scoped>

</style>
